import { createSelector } from "@reduxjs/toolkit";

export const loadWeeksOpened = createSelector(state => state.options, options => options.weeksOpened);
export const refreshWeeks = createSelector(state => state.options, options => options.refreshWeeks);

export const loadBatchId = createSelector(state=> state.options, options=> options.batchId);


export const loadDayId = createSelector(state=> state.options, options=> options.dayId);